
export default {
    props: {
        sessionId: { type: String, required: true },
        email: { type: String, default: '' },
        emailLocked: { type: Boolean, default: false },
    },
    data () {
        return {
            localEmail: this.email || '',
            loading: false,
            sent: false,
        }
    },
    computed: {
        isValid () {
            return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.localEmail) && !this.emailLocked
                ? true
                : (this.emailLocked && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email)
                    ? true
                    : /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.localEmail))
        },
    },
    methods: {
        async submit () {
            if (!this.isValid) return
            this.loading = true
            try {
                await this.$api.$post(
                    `/api/scheduling/wizard-state/${encodeURIComponent(this.sessionId)}/email-link/`,
                    { email: this.localEmail },
                )
                this.sent = true
            } catch (err) {
                this.$alert({
                    message: err?.message || 'Could not send the email. Try again in a moment.',
                    variant: 'danger',
                })
            } finally {
                this.loading = false
            }
        },
    },
}
